export default __webpack_public_path__ + "static/media/business_show_3.430054ae.png";